module.exports = __webpack_public_path__ + "img/app-icon.5b3323a8.webp";